<template>
  <b-container>
    <!-- Cообщения -->
    <div id="app-msgs" class="container"></div>

    <b-row id="content">
      <b-col xl="6" lg="7" md="10">
        <h2 class="mb-4">{{ $t("forgot.h") }}</h2>
        <p>{{ $t("forgot.p") }}</p>

        <b-form @submit="onSubmit">
          <b-overlay :show="loading" variant="white" opacity="0.7">
            <div style="min-height: 8em">
              <!-- ### Email ################################################## -->
              <b-form-group
                id="input-group-1"
                :label="$t('login.form.email.label')"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  :disabled="loading"
                  v-model="$v.form.email.$model"
                  :state="validateState('email')"
                  v-on:input="onChanged"
                  aria-describedby="input-1-ifeedback"
                  :placeholder="$t('login.form.email.ph')"
                  autofocus
                  ref="email_input"
                ></b-form-input>
                <b-form-invalid-feedback id="input-1-ifeedback">{{
                  $t("form.validEmail")
                }}</b-form-invalid-feedback>
              </b-form-group>

              <div
                :class="{
                  fadeOut: !isMessageVisible,
                  fadeIn: isMessageVisible,
                }"
                class="text-danger mb-4"
              >
                {{ $t(message) }}
              </div>
            </div>
          </b-overlay>

          <b-container class="p-0">
            <b-row>
              <b-col sm="6">
                <b-button
                  type="submit"
                  variant="primary"
                  class="w-100"
                  :disabled="loading"
                  >{{ $t("button.continue") }}</b-button
                >
              </b-col>
            </b-row>
          </b-container>
        </b-form>

        <!-- ### Log-in etc. ###################################### -->
        <div class="router" ref="container">
          <router-link :to="{ name: 'sign-in' }">{{
            $t("login.signin")
          }}</router-link>
          <router-link :to="{ name: 'sign-up-form' }">{{
            $t("login.signup")
          }}</router-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { LONG_DESIGN_DELAY, URL_RESET_PASSWORD_REQUEST } from "@/globals";
import * as errs from "@/util/errors";

export default {
  name: "PasswordRecovery",
  mixins: [validationMixin],
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      loading: false,
      message: "",
      messageVisible: false,
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  computed: {
    isMessageVisible() {
      return this.messageVisible;
    },
  },
  methods: {
    onChanged() {
      this.hideMessage();
    },
    showMessage(msg) {
      this.message = msg;
      this.messageVisible = true;
    },
    hideMessage() {
      this.message = "";
      this.messageVisible = false;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.$post(
        URL_RESET_PASSWORD_REQUEST,
        { email: this.form.email },
        true,
        true,
        LONG_DESIGN_DELAY
      )
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "checkEmail" });
        })
        .catch((e) => {
          switch (e.code) {
            case errs.CODE_ACC_USER_NOT_FOUND:
              this.showMessage("forgot.notFound");
              break;
            case errs.CODE_ACC_TO_FAST:
              this.showMessage("forgot.tooFast");
              break;
            default:
              this.$alert.show(e);
              break;
          }
          this.loading = false;
          Vue.nextTick(() => {
            const element = this.$refs["email_input"];
            element.focus();
            element.select();
          });
        });
    },
  },
};
</script>

<style>
@import "../../animation.scss";
</style>

